import { offerInitialValues, onCancelClick, submitOffer, todayDate, useRef, useRouter, useState, useEffect, useTranslation, OfferActions, ApplicationFilter, offerValidationSchema } from '@/imports-files/pages/clients/candidates/kanban';
import {
  InputError,
  Form,
  FormikControl,
  Formik, Field,
  NumberField,
  AutocompleteError, components, Loading,
  Exclamation
} from "@/imports-files/pages/clients/jobs/new";
import { setFilledDate } from "@/imports-files/components/job-filters";
import PageStyle from '@/styles/pages/jobs/add-offer/_index.module.scss';
import Button from '@/components/button';
import Image from 'next/image';
import { Checkbox } from '@material-ui/core';
import { ButtonToolbar } from 'react-bootstrap';
import PlaceAutoComplete from 'react-places-autocomplete';
import { Close } from "@/imports-files/components/common-modal/common-modal";

export default function AddOffer({ offerHash, setOfferHash, setShowOffer, router, from, setJobData, setInitialData, setShowLoader, candidateIndex=null, paramStageId=null, syncNowBtnClick=false, setHiredSyncNowBtn=null, setHiredSyncModal=null}) {
  const formRef = useRef();
  const selectDropdownRef = useRef();
  const approvalDropdownRef = useRef(null);
  const salary_duration = offerHash.salary_duration
  const currency = offerHash.currency
  const [initialValues, setInitialValues] = useState({})
  const [offerId, setOfferId] = useState()
  const offer_id = offerHash.offer?.id
  const [currencySymbol, setCurrencySymbol] = useState(currency[0].symbol)
  const [selectedDate, setSelectedDate] = useState(offerHash.offer && offerHash.offer.offer_status == 'draft' ? offerHash.offer.start_date : '');
  const Placeholder = (props) => { return <components.Placeholder {...props} />; };
  const { t, i18n } = useTranslation();
  const [approvalOptions, setApprovalOptions] = useState([]);
  const offerActions = new OfferActions(setApprovalOptions, approvalDropdownRef);
  const [approverEmail, setApproverEmail] = useState('');
  const [approverEmailError, setApproverEmailError] = useState('');
  const [users, setUsers] = useState([])
  const [requiredApproverOption, setRequiredApproverOption] = useState([]);
  const editorRef = useRef(null);
  const [saveValue, setSaveValue] = useState();
  const [checkLocationValidaton, setCheckLocationValidation] = useState(false);
  const [isSafari, setIsSafari] = useState(false);

  useEffect(async () => {
    if (offerHash) {
      let data = offerInitialValues(offerHash)
      await setInitialValues(data);
      if(offerHash.offer && offerHash.offer.offer_status == 'draft'){
        formRef.current.setFieldValue('offer.salary_period', offerHash.offer.salary_period);
        formRef.current.setFieldValue('offer.start_date', offerHash.offer.start_date);
        formRef.current.setFieldTouched('offer.start_date', true);
      }
      else{
        await selectDropdownRef.current.select.clearValue();
        formRef.current.setFieldValue('offer.salary_period', '');
        formRef.current.setFieldValue('offer.start_date', '');
        formRef.current.setFieldTouched('offer.start_date', false);
      }

      formRef.current.setFieldValue('offer.checkValidation', false);
      await setOfferId(offerHash.offer?.id)
      await setCurrencySymbol(currency.filter((x) => x.value == offerHash.currency_id)[0]?.symbol || currency[0].symbol)
      await offerActions.setOptions(offerHash.offer?.approvers?.length || 0)
    }

  }, [offerHash])

  useEffect(() => {
    if (typeof window !== "undefined") {
      const userAgent = navigator.userAgent;
      setIsSafari(userAgent.includes("Safari") && !userAgent.includes("Chrome"));
    }
  }, []);

  function handleIsRemote(event, formik) {
    let isChecked = event.target.checked
    let inputName = event.target.getAttribute('name')
    formik.setFieldValue('offer.location_attributes.full_address', '');
    formik.setFieldValue(inputName, isChecked);
  }

  function handleSubmitButtonState(formik, btnType){

     if(formik.values.offer.remote){
        setCheckLocationValidation(false);
      }else{
        setCheckLocationValidation(true);
      }

    if(btnType == 'save'){
      formik.values.offer.is_save = true ;
      setSaveValue(false);
      formik.validateForm().then(()=>{
        formik.submitForm();
      })
    }
    else{
      delete formik.values.offer.is_save;
      setSaveValue(true);
       formik.validateForm().then(async()=>{
        formik.submitForm();
      })
    }
  }
function shouldFetchSuggestions(formik) {
    return formik.values.offer.location_attributes?.full_address?.length >= 3

  }

  return (
    <>
      {initialValues.offer && <div className={`${PageStyle.AddOffer} ${PageStyle.JobList} ${PageStyle.NewJob}`}>
        <div className={PageStyle.NewJob__Container}>
          <div className={PageStyle.NewJob__TopSection}>
            <div className={PageStyle.ClientCompany__BackSection}>
              <span onClick={async () => {
                await setShowOffer(false)
                onCancelClick();
              }}
              >
                <Image src='/new-icons/close.svg' height={13} width={13} alt="" />
                <span className={`ml15`}>Close</span>
              </span>
            </div>
          </div>

    

          <div className={PageStyle.ClientCompany__FormSection}>
            <h1 className={PageStyle.ClientCompany__Heading}>
              {syncNowBtnClick && offerHash.stage_name == "Hired" ? "Data Sync Form" : "Create Offer"}
            </h1>
          </div>

          <div className={PageStyle.AddCandidatesForm}>
            <Formik
              initialValues={initialValues}
              validationSchema={offerValidationSchema(saveValue, checkLocationValidaton)}
              innerRef={formRef}
              onSubmit={(values, actions) => {
                values.offer.salary = values.offer.salary.toString().replaceAll(',', '')
                values.kanban = {candidate_index: candidateIndex, base_stage_id: paramStageId}
                let sortByFilterData = ApplicationFilter(router.query.job_id);
                if(sortByFilterData){
                  values.application_filter_data = sortByFilterData;
                  }
                const errors = submitOffer({ values: values, router: router, formik: formRef, from: from, setJobData: setJobData, setShowOffer: setShowOffer, router, offer_id: offer_id, setInitialData: setInitialData, setShowLoader: setShowLoader, syncNowBtnClick: syncNowBtnClick, setHiredSyncNowBtn: setHiredSyncNowBtn, setHiredSyncModal: setHiredSyncModal})
                actions.setErrors(errors)
              }
              }
            >
              {(formik) => (
                <Form className={PageStyle.Form}>
                  <div className={PageStyle.Form__Table}>
                    <h4 className={PageStyle.ClientCompany__Subheading}>Candidate</h4>


                  </div>
                  <div className={PageStyle.Form__TableRowTwoGrid}>
                    <div className={PageStyle.Form__TableCol}>
                      <span className={PageStyle.Form__Label}>
                        Name *
                      </span>

                      <FormikControl
                        control="input"
                        type="text"
                        // placeholder="Name"
                        name="offer.name"
                        className={PageStyle.Form__Input}
                        formik={formik}
                        // disabled= {true}
                        errorclass={PageStyle.Form__Error}
                        style={InputError(
                          formik,
                          "offer.name"
                        )}
                      />
                    </div>
                    <div className={PageStyle.Form__TableCol}>
                      <span className={PageStyle.Form__Label}>
                        Email *
                      </span>

                      <FormikControl
                        control="input"
                        type="text"
                        // placeholder="Email address"
                        name="offer.email"
                        formik={formik}
                        className={PageStyle.Form__Input}
                        errorclass={PageStyle.Form__Error}
                        // disabled={offerHash.email && offerHash.email.length > 0 }
                        style={InputError(
                          formik,
                          "offer.email"
                        )}
                      />
                    </div>
                  </div>

                  <div className={PageStyle.Form__TableRowTwoGrid}>
                    <div className={PageStyle.Form__TableCol}>
                      <span className={PageStyle.Form__Label}>
                        Phone *
                      </span>
                      <FormikControl
                        control="input"
                        type="text"
                        // placeholder="Phone Number"
                        name="offer.contact_no"
                        formik={formik}
                        className={PageStyle.Form__Input}
                        errorclass={PageStyle.Form__Error}
                        // disabled={offerHash.contact_no && offerHash.contact_no.length > 0 }
                        style={InputError(
                          formik,
                          "offer.contact_no"
                        )}
                      />
                    </div>

                    <div className={PageStyle.Form__TableCol}>
                      <span className={PageStyle.Form__Label}>
                        Offer Start Date *
                      </span>
 
                      <FormikControl
                        control       =   "customDatePicker"
                        className     =   {'FilterCustomDateTime FilterCustomEndDate'}
                        format        =   "DD/MM/yyyy"
                        formik        =   {formik}
                        inputProps    =   {{
                                              disabled: false,
                                              placeholder: "Select Date",
                                              readOnly: true,
                                              style: InputError(formik, 'offer.start_date'),
                                          }}
                        disablePast  =   {new Date()}
                        name          =   "offer.start_date"
                        onChange      =   {(moment) => {
                                                formik.setFieldValue('offer.start_date', moment.format('DD/MM/YYYY'));
                                                setSelectedDate(moment)
                                              }}
                        value         =   {typeof selectedDate == 'string' ? setFilledDate(selectedDate) : selectedDate}
                        
                      />
                    </div>

                  </div>

                  <div className={PageStyle.AddOffer__Addbg}>
                    <h4 className={PageStyle.ClientCompany__Subheading}>Job</h4>
                    <div className={PageStyle.Form__TableRowTwoGrid}>
                      <div className={PageStyle.Form__TableCol}>
                        <span className={PageStyle.Form__Label}>
                          Job title *
                        </span>
                        <FormikControl
                        control="input"
                        type="text"
                        // placeholder="Phone Number"
                        name="offer.job_title"
                        formik={formik}
                        className={PageStyle.Form__Input}
                        errorclass={PageStyle.Form__Error}
                        style={InputError(formik,"offer.job_title")}
                        // disabled={offerHash.contact_no && offerHash.contact_no.length > 0 }
                      />

                        {/* <FormikControl */}
                        {/*   control="input" */}
                        {/*   type="text" */}
                        {/*   // placeholder="Jhony Jhon" */}
                        {/*   value={formik.values.offer.title} */}
                        {/*   className={`${PageStyle.Form__Input}`} */}
                        {/* /> */}
                      </div>


                      <div className={PageStyle.Form__TableCol}>
                        <div className={PageStyle.Form__Remotegrid}>
                          <span className={PageStyle.Form__Label}>
                            Location *
                          </span>
                          <span className={`Dpflex ${PageStyle.Form__CheckLabel}`}>
                            {/* <Checkbox checked={formik.values.offer.remote} disabled={true} /> */}
                            <Checkbox
                              inputProps={{ "aria-label": "Checkbox A" }}
                              onChange={(event) => handleIsRemote(event, formik)}
                              checked={formik.values.offer.remote}
                              name="offer.remote"
                            />{" "}
                            Remote
                          </span>
                        </div>

                        {<PlaceAutoComplete
                          value={formik.values.offer.location_attributes.full_address}
                          onChange={async (value) => {
                                                      await formik.setFieldValue('offer.location_attributes.full_address', value)
                                                     }}
                          onSelect={(address, suggestion) => {
                            formik.setFieldValue('offer.location_attributes.full_address', address)
                          }}
                          shouldFetchSuggestions={shouldFetchSuggestions(formik)}
                        >

                          {({ getInputProps, getSuggestionItemProps, suggestions, loading }) => (

                            <div className="autocomplete-root">
                              <Field
                                className={PageStyle.Form__Input}
                                disabled={formik.values.offer.remote}
                                name="offer.location_attributes.full_address"
                                placeholder={"Enter postcode or complete address"}
                                style={InputError(formik, "offer.location_attributes.full_address")}
                                {...getInputProps({ disabled: formik.values.offer.remote })}
                              />

                              <div className="autocomplete-dropdown-container">
                                {loading && <div> {t('page:clients:job-form:texts:loading')} </div>}
                                {suggestions.map(suggestion => (
                                  <div key={suggestion.placeId} {...getSuggestionItemProps(suggestion)}>
                                    <span key={suggestion.id}>{suggestion.description}</span>
                                  </div>
                                ))}
                              </div>

                            </div>
                          )}
                        </PlaceAutoComplete>}
                        <AutocompleteError
                          name="offer.location_attributes.full_address"
                          errorClass={PageStyle.Form__Error}
                          formik={formik}
                          style={InputError(formik, "offer.location_attributes.full_address")}
                          custom_error_90={'custom_error_90'}
                        />
                      </div>
                    </div>

                    <div className={PageStyle.Form__TableRowTwoGrid}>
                      <div className={PageStyle.Form__TableCol}>
                        <span className={PageStyle.Form__Label}>
                          Employment Type *
                        </span>
                        <div className={`wrapper`}>
                          <Field type="radio" name="offer.employment_type" id="option-1" value="full_time"  />
                          <Field type="radio" name="offer.employment_type" id="option-2" value="part_time"  />
                          <Field type="radio" name="offer.employment_type" id="option-3" value="either"/>

                          <label htmlFor="option-1" className={`option option-1 }`}>
                            <span>{t('page:clients:job-form:texts:full_time')}</span>
                          </label>
                          <label htmlFor="option-2" className={`option option-2 `}>
                            <span>{t('page:clients:job-form:texts:part_time')}</span>
                          </label>

                          <label htmlFor="option-3" className={`option option-3`}>
                            <span>{t('page:clients:job-form:texts:either')}</span>
                          </label>
                        </div>

                        <AutocompleteError
                          name="offer.employment_type"
                          errorClass={PageStyle.Form__Error}
                          formik={formik}
                          style={InputError(formik, "offer.employment_type")}
                        />
                      </div>
                    </div>

                    <div className={PageStyle.Form__TableRowTwoGrid}>
                      <div className={PageStyle.Form__TableCol}>
                        <span className={PageStyle.Form__Label}>
                          Contract Type *
                        </span>
                        <div className={`wrapper2`}>
                          <Field type="radio" name="offer.contract_type" id="option-4" value="permanent" />
                          <Field type="radio" name="offer.contract_type" id="option-5" value="contract" />
                          <Field type="radio" name="offer.contract_type" id="option-6" value="temporary" />
                          <Field type="radio" name="offer.contract_type" id="option-7" value="internship" />

                          <label htmlFor="option-4" className={`option option-4`}>
                            <span>{t('page:clients:job-form:texts:permanent')}</span>
                          </label>
                          <label htmlFor="option-5" className={`option option-5`}>
                            <span>{t('page:clients:job-form:texts:contract')}</span>
                          </label>

                          <label htmlFor="option-6" className={`option option-6`}>
                            <span>{t('page:clients:job-form:texts:temporary')}</span>
                          </label>

                          <label htmlFor="option-7" className={`option option-7`}>
                            <span>{t('page:clients:job-form:texts:internship')}</span>
                          </label>
                        </div>

                        <AutocompleteError
                          name="offer.contract_type"
                          errorClass={PageStyle.Form__Error}
                          formik={formik}
                          style={InputError(formik,"offer.contract_type")}
                        />
                      </div>
                    </div>

                    <div className={PageStyle.Form__TableRowThreeGrid}>
                      <div className={PageStyle.Form__TableCol}>
                        <span className={`${PageStyle.Form__Label}`}>
                          Salary *
                        </span>
                        {/* <FormikControl */}
                        {/*   control           =   "input" */}
                        {/*   type              =   "number" */}
                        {/*   pattern           =   "\d*" */}
                        {/*   min               =   "0" */}
                        {/*   placeholder       =   "e.g. £30,000" */}
                        {/*   name              =   "offer.salary" */}
                        {/*   formik            =   {formik} */}
                        {/*   // infoPlaceholder   =   "Salary" */}
                        {/*   className         =   {PageStyle.Form__Input} */}
                        {/*   errorclass        =   {PageStyle.Form__Error} */}
                        {/*   style             =   {InputError( */}
                        {/*                                      formik, */}
                        {/*                                      "offer.salary" */}
                        {/*                                    )} */}
                        {/* /> */}
                        <div className={PageStyle.Form__Input_currency}>
                          <span className={PageStyle.Form__currency_symbol}>{currencySymbol}</span>
                          <Field component={NumberField} type="text" placeholder={"e.g. 30,000"} name={"offer.salary"} className={PageStyle.Form__Input} disabled={false} formik={formik} style={InputError(formik, 'offer.salary')} />
                        </div>
                        <AutocompleteError
                          name="offer.salary"
                          errorclass={PageStyle.Form__Error}
                          formik={formik}
                          style={InputError(formik, "offer.salary")}
                        />
                      </div>

                      <div className={PageStyle.Form__TableCol}>
                        <span className={`${PageStyle.Form__Label}`}>
                          Salary Period *
                        </span>
                        <FormikControl
                          control="select"
                          type="select"

                          name="offer.salary_period"
                          formik={formik}
                          className={PageStyle.Form__CustomSelect}
                          errorclass={PageStyle.Form__Error}
                          options={salary_duration}
                          default={formik.values.offer.salary_period}
                          onChange={(option) => formik.setFieldValue("offer.salary_period", option?.value)}
                          reference={selectDropdownRef}
                          style={InputError(
                            formik,
                            "offer.salary_period"
                          )}
                        />
                      </div>
                      <div className={PageStyle.Form__TableCol}>
                        <span className={`${PageStyle.Form__Label}`}>
                          Currency *
                        </span>

                        <FormikControl
                          control="select"
                          type="select"
                          placeholder="Select Currency"
                          // infoPlaceholder   =   "Currency"
                          isCurrency={true}
                          currencySymbol={currencySymbol}
                          name="offer.currency_id"
                          formik={formik}
                          className={PageStyle.Form__CustomSelect}
                          errorclass={PageStyle.Form__Error}
                          options={currency}
                          default={formik.values.offer.currency_id || currency[0].value}
                          style={InputError(
                            formik,
                            "offer.currency_id"
                          )}
                          onChange={(option) => {
                              setCurrencySymbol(option.symbol)
                              formik.setFieldValue("offer.currency_id", option.value)
                            }}
                          // disabled={true}
                        />

                      </div>

                    </div>
                    <div className={`${PageStyle.Form__TableRowTwoGrid} benefitstext`}>
                      <div className={PageStyle.Form__TableCol}>
                        <span className={` ${PageStyle.Form__Label}`}>
                          Benefits {/* <span className={PageStyle.Form__Cont}>Optional</span> */}
                        </span>
                        {!isSafari && (
                          <div className={`${PageStyle.Form__NotSupportW100} NotSupport`}>
                            <Exclamation /> {`Your browser doesn't support direct clipboard access. Please use the keyboard shortcuts: Ctrl+X/C/V (Windows) or ⌘+X/C/V (Mac).`}
                          </div>
                        )}
                        <FormikControl                         
                          apiKey={process.env.NEXT_PUBLIC_TINYMCE_API_KEY}
                          control="customEditor"
                          formik={formik}
                          textareaName="offer.benefits"
                          onInit={(evt, editor) => editorRef.current = editor}
                          style={InputError(formik, `offer.benefits`)}
                          value={formik.values.offer.benefits}
                          onEditorChange={(value) => { formik.setFieldValue("offer.benefits", value) }}
                          init={{
                            height: 250,
                            menubar: false,
                            resize: false,
                           // readOnly: !editable,
                            plugins: [
                              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                              'insertdatetime', 'media', 'table', 'help', 'wordcount',  'contextmenu', 'paste' 
                              ],
                            toolbar: 'undo redo | blocks | ' +
                              'bold italic backcolor | link | alignleft aligncenter ' +
                              'alignright alignjustify | bullist numlist outdent indent | ' +
                              'removeformat | help',
                            content_style: 'body { font-family:Gellix; font-size:14px }',
                            link_target_list: false,
                            contextmenu: isSafari ? "copy paste | link" : "link",
                            paste_as_text: true, 
                          }}
                        >
                        </FormikControl>
                      </div>
                    </div>
                    <div className={PageStyle.Form__TableRowTwoGrid}>
                      <div className={`${PageStyle.Form__TableCol}`}>
                        <span className={PageStyle.Form__Label}> {t('page:clients:job-form:texts:approver')} </span>

                     
                        <div className={`${PageStyle.Form__InputSection} ${PageStyle.Form__width} noplaceholderspace  AutosuggestOpenUp`}>

                          <FormikControl
                            control="autosuggestInput"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            getSuggestionValue={offerActions.getUserSuggestionValue}
                            inputProps={{
                              className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                              formik: formik,
                              index: 'approver_user_email',
                              name: "offer.offer_approvals_attributes_0_approver_emails",
                              onChange: (value, { newValue, method }) => {
                                setApproverEmail(newValue);
                                setApproverEmailError('');
                              },
                              placeholder: "Start typing name or work email",
                              style: InputError(formik, "offer.offer_approvals_attributes_0_approver_emails"),
                              value: approverEmail,
                              onKeyDown: (event) =>offerActions.handleKeyDown(event, formik, setApproverEmail, setApproverEmailError),
                              setApproverEmail: setApproverEmail,
                              setApproverEmailError: setApproverEmailError
                            }}
                            onSuggestionsClearRequested={() => offerActions.onUserSuggestionsClearRequested(setUsers)}
                            onSuggestionsFetchRequested={(hash) => {
                              offerActions.onUserSuggestionsFetchRequested(hash, setUsers)
                                                            }}
                            onSuggestionSelected={(event, { suggestion }) => {
                              if (suggestion.user_attributes.email.length > 0) {
                                setApproverEmail('');
                                offerActions.onUserSuggestionSelection(formik, formik.values.offer.offer_approvals_attributes[0].approver_emails, suggestion.user_attributes.email, formik.values.offer.offer_approvals_attributes[0].approver_initials, {email: suggestion.user_attributes.email, name_initials: suggestion.user_attributes.name_initials, name: suggestion.user_attributes.name, photo_url:suggestion.user_attributes.photo_url})
                              }
                            }}
                            renderInputComponent={offerActions.renderInputComponent}
                            renderSuggestion={offerActions.renderUserSuggestion}
                            shouldRenderSuggestions={offerActions.shouldRenderSuggestions}
                            suggestions={users}
                            type="text"
                            autoComplete="password"


                          />
                 
                          {approverEmailError && approverEmailError.length >0 && <p>{approverEmailError}</p>}
                          <div className={PageStyle.Tagrow}>
                            {formik.values.offer.offer_approvals_attributes[0]?.approver_initials?.map((item, index) => (
                              <div className={PageStyle.Tagrow__Tags} key={`job_approvers_${index}`}>
                                {item?.photo_url ? <img src={item?.photo_url} className="JobImageSmall" />
                                  : item.name_initials && <div className={PageStyle.Tagrow__Prefix}>{item.name_initials}</div>}
                                {item.name ? <span>{item.name}</span> : <span>{item.email}</span>}
                                <button
                                  type="button"
                                  className={PageStyle.Tagrow__Cancel}
                                  onClick={() => offerActions.handleEmailDelete(formik, index)}
                                >
                                  <Close/>
                                </button>
                              </div>
                            ))}

                          </div>
                        </div>

                      </div>

                      {approvalOptions.length > 0 && <div className={PageStyle.Form__TableCol}>
                        <span className={PageStyle.Form__Label}>
                          {t('page:clients:job-form:texts:required_approver')}
                        </span>
                        
                        <div className={`${PageStyle.Form__InputSection} ${PageStyle.Form__width} noplaceholderspace AutosuggestOpenUp`}>
                          <FormikControl
                            className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto}`}
                            components={{ Placeholder }}
                            control="select"
                            default={formik.values.offer.offer_approvals_attributes[0].minimum_approval_required}
                            formik={formik}
                            name={`offer.offer_approvals_attributes.${0}.minimum_approval_required`}
                            onChange={(option) => option != null ? formik.setFieldValue(`offer.offer_approvals_attributes.${0}.minimum_approval_required`, option.value) : ''}
                            options={approvalOptions}
                            style={InputError(formik, `offer.offer_approvals_attributes.${0}.minimum_approval_required`)}
                            reference={approvalDropdownRef}
                          />

                        </div>
                      </div>}
                    </div>
                 
                  </div>

                  <div className="space"></div>
                  <div className={`${PageStyle.NewJob__SubmitSection} ${syncNowBtnClick && offerHash.stage_name == "Hired" ? PageStyle.TwoButtonAlign : PageStyle.ButtonAlign}`}>
                    <Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={async () => {
                      await setShowOffer(false);
                      onCancelClick()
                    }
                    }> Cancel </Button>
                    <Button buttonstyle={PageStyle.primarybtn} type="button" onClick={() => handleSubmitButtonState(formik, "save")}>{syncNowBtnClick && offerHash.stage_name == "Hired" ? "Sync with charlie" : "Save"}</Button>
                    { offerHash.stage_name != "Hired" ? <Button buttonstyle={PageStyle.primarybtn} type="button" onClick={() => handleSubmitButtonState(formik, "save&continue")}>Save and Send</Button> : "" }

                  </div>
  
                </Form>
              )}
          </Formik>
        </div>

      </div>

      </div>}

    </>
  )
}